import { defineStore } from 'pinia';

export const useVeterinariaStore = defineStore('veterinariaStore', {
    state: ()=> ({
        veterinaria: null,
        main_veterinaria: null
    }),
    actions: {
        setVeterinaria(veterinaria) {
            this.veterinaria = veterinaria;
        },
        getVeterinaria() {
            return this.veterinaria;
        },
        setMainVeterinaria(veterinaria) {
            this.veterinaria = veterinaria;
        },
        getMainVeterinaria() {
            return this.veterinaria;
        },
    },
    persist: {
        storage: localStorage
    }
});